import palette from "../palette";

export default {
    colorPrimary: {
        backgroundColor: `${palette.background.neutral} !important`, 
    },
    bar: {
        backgroundColor: `${palette.background.primary} !important`, 
    },
}